import React from 'react';

import {Button} from "../Button";
import {RadioInputField} from "../FormField";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {PageLoader} from "../Loader";

class SurveyVote extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            choices: this.props.survey.choices || []
        };
        this.handleUniqueVote = this.handleUniqueVote.bind(this);
        this.handleMultipleVote = this.handleMultipleVote.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleUniqueVote(id, value) {
        let vote = this.state.choices;
        vote.forEach(item => {
            if(item.isVoted === true){
                item.isVoted = false
            }
        });
        let voteIndex = vote.findIndex(item => item._id === id);
        vote[voteIndex].isVoted = value;
        this.setState({vote});
    }

    handleMultipleVote(id, value) {
        let vote = this.state.choices;
        let voteIndex = vote.findIndex(item => item._id === id);
        vote[voteIndex].isVoted = value;
        this.setState({vote});
    }

    handleSubmit(){
        console.log("ok");
        this.props.handleClose();
    }

    render() {
        return !this.props.surveyInitialized ? (
           <div className={"modal-container survey-edit"}>
               <PageLoader />
           </div>
        ) : (
            <div className={"modal-container survey-edit"}>
                <div className={"modal-topline"}>
                    <span className={"question-label"}>Question</span>
                    <span>{this.props.survey.name}</span>
                </div>
                <div className={"modal-body"}>
                    {this.state.choices.map(vote => {
                        return(
                            <RadioInputField key={vote._id}
                                            onClick={() => this.props.survey.multiple ? this.handleMultipleVote(vote._id, !vote.isVoted) : this.handleUniqueVote(vote._id, true)}
                                            label={vote.name}
                                            htmlFor={vote._id}
                                            id={vote._id}
                                            checked={vote.isVoted} />
                        )
                    })}
                </div>
                <div className={"modal-baseline"}>
                    <Button btnStyle={"grey"}
                            size={"small"}
                            onClick={()=> this.props.handleClose()}
                            content={"Annuler"}/>
                    <Button btnStyle={"primary-reverse"}
                            size={"small"}
                            onClick={()=> this.handleSubmit()}
                            content={"Enregistrer"}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        survey: [],
        surveyLoading: false,
        surveyInitialized: true,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SurveyVote);